import { motion } from "framer-motion"
import styles from './Questions.module.scss'
import Hint from '../../components/Hint/Hint'
import {phone} from '../../utils/data'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const boxAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Questions = () => {

    return (
        <motion.section
            id='ceny'
            className={styles.main}
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            >
           
                    <div className={styles.box}>
                        <div className={styles.container}>
                            <motion.h2 className={styles.title} variants={titleAnimation}><span>Популярные вопросы</span> на тему монтажа и ремонта кровли</motion.h2>
                            <motion.ul className={styles.list} variants={boxAnimation}>
                            <Hint
                                    question='Возможен ли дешёвый ремонт крыши за полцены?'
                                >
                                <p className={styles.text}>Да, можно нанять шабашников и будет действительно дёшево. Только помните народную мудрость: разочарование от ужасного качества длится гораздо дольше, чем радость от низкой цены!</p>
                                <p className={styles.text}>Тем, кто верит в чудеса и думает, что порывшись в интернете, можно существенно сэкономить без потери качества, можно только посочувствовать. Именно такие неоправданные ожидания вырастают в истории «меня обманули/кинули недобросовестные строители».</p>
                            </Hint>
                            <Hint
                                    question='Можно ли укладывать кровлю зимой?'
                                >
                                <p className={styles.text}>Не редко с наступлением осенне-зимнего периода наши клиенты задают вопрос, можно ли выполнять кровельные работы зимой, как это отразится на стоимости и качестве.</p>
                                <p className={styles.text}>Если говорить кратко, то да монтаж и реконструкция кровли зимой возможна, более того в некоторых случаях это даже нужно делать, ведь иногда основные виды кровельных работ выполняются зимой быстрее, чем летом поскольку зимой отсутствуют осадки ввиде дождя. Стоимость строительных материалов зимой гораздо ниже, а их выбор выше. Кровельные бригады не загружены, как следствие можно выбрать подрядчика, который осуществит монтаж качественно. Согласно принятым нормам работы можно проводить при температуре до -15° C.</p>
                            </Hint>
                            <Hint
                                    question='На сколько важна подкровельная вентиляция?'
                                >
                                <p className={styles.text}>Для тех, кому лень читать, сразу можем сказать, подкровельная вентиляция очень важна и если Вы хотите продлить срок службы крыши минимум на 10 лет, то её обустройство обязательно.</p>
                                <p className={styles.text}>Абсолютно в любой конструкции крыши имеется повышенная влажность, которая возникает по нескольким причинам, главная из которых заключается в том, что разница температур внутри и снаружи кровельного материала, образует конденсат.</p>
                                <p className={styles.text}>От возникающей, повышенной влажности в кровельном пространстве страдают деревянные конструкции крыши, утеплитель, кровельное покрытие, как следствие и вся кровля в целом. Намокание утеплителя снижает его теплоизоляционные характеристики в несколько раз, а деревянные конструкции подвергаются гниению, поражению плесенью и грибками, что существенно сокращает срок службы кровли и может негативно отразиться на здоровье жильцов дома. Именно для предотвращения подобной ситуации, необходимо выполнить работы, связанные с обустройство подкровельной вентиляции.</p>
                            </Hint>
                            <Hint
                                    question='Какая нужна толщина утеплителя при утеплении мансарды?'
                                >
                                <p className={styles.text}>По рекомендациям производителей и специалистов по обустройству кровли, а также из личного опыта нашей компании, слой утеплителя при утеплении мансарды должен составлять 25-30 см. Лучше всего выполнять двойной или тройной слой, именно такой способ утепления предотвращает появление мостиков холода. При утеплении мансарды нельзя забывать о том, что фронтон является стеной чердачного помещения, а дерево, как известно требует более толстого слоя утеплителя, чем кирпичные стены.</p>
                            </Hint>
                            <Hint
                                    question='Какой материал лучше выбрать для кровли?'
                                >
                                <p className={styles.text}>Нужно учитывать эксплуатационные характеристики материала: долговечность, механическую прочность, водонепроницаемость и другие. Также стоит учесть климатические особенности местности, конфигурацию крыши и вес покрытия. </p>
                                <p className={styles.text}>Например:</p>
                                <p className={styles.text}>Мягкая черепица подходит для крыш с уклоном от 12 градусов и выше, если уклон меньше, возможны протечки. </p>
                                <p className={styles.text}>Металлочерепица лучше всего проявляет себя при уклоне от 14 градусов, при меньшем наклоне потребуется дополнительная гидроизоляция.</p>
                                <p className={styles.text}>Профнастил можно использовать даже при небольшом уклоне от 8 градусов, но важно правильно герметизировать стыки. </p>
                            </Hint>
                            <Hint
                                    question='Какой утеплитель лучше для теплой крыши?'
                                >
                                <p className={styles.text}>Лучше всего подходит минеральная вата — она обладает низкой теплопроводностью, не горит и экологически безопасна.</p>
                            </Hint>
                            <Hint
                                    question='Как часто нужно проверять состояние теплой крыши?'
                                >
                                <p className={styles.text}>Рекомендуется проводить осмотр два раза в год — весной и осенью.</p>
                            </Hint>
                            <Hint
                                    question='Что делать, если на крыше появился конденсат?'
                                >
                                <p className={styles.text}>Проверьте состояние пароизоляции и вентиляции. Возможно, потребуется замена утеплителя.</p>
                            </Hint>
                            </motion.ul>
                            <a className={styles.button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>
                                <span>Задать свой вопрос в WhatsАpp</span>
                                <svg  xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.92327 0.277344C4.59796 0.277344 0.2771 4.5982 0.2771 9.92351C0.2771 12.0559 0.967314 14.0199 2.13451 15.6192L0.905588 19.2554L4.73824 18.0602C6.23651 19.0141 8.01536 19.5697 9.92327 19.5697C15.2486 19.5697 19.5694 15.2488 19.5694 9.92351C19.5694 4.5982 15.2486 0.277344 9.92327 0.277344ZM14.3395 15.0973C12.5887 15.7988 10.5013 15.1198 8.21737 13.3858C5.93349 11.6519 4.42961 9.21085 4.3286 7.39834C4.2276 5.58582 5.70342 4.67115 6.50587 4.67676C7.30831 4.68237 8.18932 7.24683 8.20054 7.63963C8.21176 8.03805 7.21853 8.7451 7.17925 9.08179C7.13997 9.41848 8.53162 11.0795 9.12083 11.5284C9.70442 11.9717 10.9109 12.8247 11.5338 12.7461C12.151 12.6619 12.5607 11.4218 12.9535 11.3432C13.3463 11.2647 15.4899 12.3308 15.7031 12.6058C15.9164 12.8864 15.8939 14.4801 14.3395 15.0973Z"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
        </motion.section>
        
    )
}

export default Questions